import { db } from '@/config/firebase.ts';
import { InvitationCodeModel } from '@/interfaces/User.interface.ts';
import { collection, getDocs, query, where } from 'firebase/firestore';

export const getInvitationCode = async (accessCode: string): Promise<InvitationCodeModel> => {
  const invitationRef = collection(db, 'invitationCode');
  const q = query(invitationRef, where('accessCode', '==', accessCode));
  return getDocs(q).then((querySnapshot) => {
    const newData = querySnapshot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
    return newData[0];
  });
};

export const checkInvitationCodeIsValid = async (invitationCode: string, email: string): Promise<boolean> => {
  const invitationRef = collection(db, 'invitationCode');
  const q = query(invitationRef, where('code', '==', invitationCode), where('email', '==', email));
  const snapShot = await getDocs(q);
  return snapShot.size > 0;
};
